import { Link, useNavigate } from "react-router-dom";
import { Car } from "lucide-react";

export const Navbar = ({ transparent = false }) => {
  const navigate = useNavigate();
  return (
    <header
      className={`sticky top-0 z-40 border-b border-white/5 ${
        transparent ? "bg-[#0A0A0C]/60 backdrop-blur-xl" : "bg-[#0A0A0C]"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 group"
          data-testid="nav-logo-link"
        >
          <span className="w-8 h-8 rounded-lg bg-amber-500/15 border border-amber-500/40 flex items-center justify-center group-hover:bg-amber-500/25 transition">
            <Car className="w-4 h-4 text-amber-400" />
          </span>
          <span className="font-display text-base sm:text-lg font-extrabold uppercase tracking-wider">
            GETEASY <span className="text-amber-400">CAR</span>
          </span>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-3">
          <button
            onClick={() => navigate("/find-my-car")}
            data-testid="nav-find-car-btn"
            className="text-xs sm:text-sm text-slate-300 hover:text-white px-3 py-2 rounded-lg hover:bg-white/5 transition"
          >
            Find a Car
          </button>
          <button
            onClick={() => navigate("/track")}
            data-testid="nav-track-btn"
            className="text-xs sm:text-sm text-slate-300 hover:text-white px-3 py-2 rounded-lg hover:bg-white/5 transition"
          >
            Track
          </button>
          <button
            onClick={() => navigate("/policies")}
            data-testid="nav-policies-btn"
            className="hidden sm:inline-flex text-xs sm:text-sm text-slate-300 hover:text-white px-3 py-2 rounded-lg hover:bg-white/5 transition"
          >
            Policies
          </button>
          <button
            onClick={() => navigate("/admin/login")}
            data-testid="nav-admin-btn"
            className="text-xs sm:text-sm text-amber-400 hover:text-amber-300 px-3 py-2 rounded-lg hover:bg-amber-500/10 transition border border-amber-500/20"
          >
            Admin
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
